import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { ProgressBarItem } from '@frontend-site/shared/data';
@Component({
    selector: 'p-multiple-progress-bar',
    template: `
        <div class="p-multiple-progress-bar">
            <p-link
                *ngIf="linkLabelPart !== undefined; else textLabel"
                class="p-multiple-progress-bar-label p-paragraph-1 progress-label"
                (onClick)="linkClicked.emit()"
            >
                {{ linkLabelPart }}/{{ totalValue }}
            </p-link>
            <ng-template #textLabel>
                <p *ngIf="label" class="p-multiple-progress-bar-label p-paragraph-1 progress-label p-field-label">
                    {{ label }}
                </p>
            </ng-template>
            <div class="progress {{ width }}" [matTooltip]="displayTooltip ? tooltip : ''" matTooltipClass="p-tooltip">
                <div *ngFor="let item of values" class="progress-bar" role="progressbar" [style]="item.style"></div>
            </div>
        </div>
    `,
    styleUrls: ['./p-multiple-progress-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PMultipleProgressBarComponent {
    @Input() label?: string;
    @Input() displayTooltip = true;
    @Input() linkLabelPart?: number;
    @Input() isFullWidth? = false;
    @Output() linkClicked = new EventEmitter<void>();

    get width(): string {
        return this.isFullWidth ? 'full-width' : 'regular-width';
    }

    totalValue = 0;
    tooltip = '';
    private _values: ProgressBarItem[] = [];

    @Input()
    set values(values: ProgressBarItem[]) {
        this.totalValue = 0;
        this.tooltip = '';
        values.forEach((item) => {
            this.totalValue += item.value;
            this.tooltip += `${item.label}: ${item.value}\n`;
        });
        this._values = values.map((item) => ({ ...item, style: this.getStyle(item) }));
    }
    get values(): ProgressBarItem[] {
        return this._values;
    }

    private getStyle(item: ProgressBarItem): string {
        return `width: ${(item.value / this.totalValue) * 100}%; background-color: ${item.color}`;
    }
}
